import { auth } from "../firebase";
import ENV from "../env";

const request = async (path, options = {}) => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error("Authentication required");
  const response = await fetch(`${ENV.firebaseApiUrl}/ai${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || "AI request failed");
    error.code = data.code;
    throw error;
  }
  return data;
};

const post = (path, body) => request(path, { method: "POST", body: JSON.stringify(body) });

export const generateTicketingCover = (payload) => post("/ticketing/cover/generate", payload);
export const finalizeTicketingCover = (payload) => post("/ticketing/cover/finalize", payload);
export const getTicketingCoverStatus = ({ orgId, draftId, eventId }) =>
  request(
    `/ticketing/cover/status?orgId=${encodeURIComponent(orgId)}&draftId=${encodeURIComponent(draftId || "")}&eventId=${encodeURIComponent(eventId || "")}`,
  );
export const rewriteTicketingDescription = (payload) =>
  post("/ticketing/rewrite-description", payload);
export const translateTicketingDescriptions = (payload) =>
  post("/ticketing/translate-descriptions", payload);
export const analyzeBudgetDocument = (budgetId, payload) =>
  post(`/budgets/${budgetId}/analyze-document`, payload);
export const analyzeMenu = (payload) => post("/menu/analyze", payload);
export const getMenuImport = (importId) => request(`/menu/imports/${importId}`);
export const commitMenuImport = (importId, candidates, generateIcons = false) =>
  post(`/menu/imports/${importId}/commit`, { candidates, generateIcons });
export const retryMenuIcons = (importId) => post(`/menu/imports/${importId}/retry-icons`, {});
export const regenerateAllIcons = (orgId) => post("/icons/regenerate-all", { orgId });
export const generateProductIcon = ({ orgId, productId, collectionName = "products" }) =>
  post("/icons/generate", { orgId, productId, collectionName });
export const previewProductIcon = ({ orgId, title, category }) =>
  post("/icons/preview", { orgId, title, category });
export const analyzeAccreditationsCsv = (payload) =>
  post("/accreditations/analyze-csv", payload);
export const analyzeNoteAudio = ({ orgId, noteId, audio }) =>
  post(`/notes/${encodeURIComponent(noteId)}/analyze-audio`, { orgId, audio });
